import { Component, OnDestroy, OnInit, QueryList, ViewChild } from '@angular/core';
import { Global } from 'src/app/core/resources/global';
import PlaceResult = google.maps.places.PlaceResult;
import * as _ from 'lodash';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { Utils } from 'src/app/core/resources/utils';
import { City } from 'src/app/core/interfaces/city';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { OriginReteicaService } from 'src/app/core/services/origin-reteica.service';
import { Company } from 'src/app/core/interfaces/company';
import { AuthService } from 'src/app/core/services/authentication.service';
import { UploadLocationComponent } from '../upload-location/upload-location.component';
import { DownloadLocationComponent } from '../download-location/download-location.component';
import { ThirdPartyConsignmentComponent } from '../third-party-consignment/third-party-consignment.component';
import { MatDialog } from '@angular/material/dialog';
import { BranchOffice } from 'src/app/core/interfaces/branch-offices';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { NgxSpinnerService } from 'ngx-spinner';
import { StandardMapComponent } from 'src/app/shared/standard-map/standard-map.component';
import { CargoResources } from '../../resources/cargo';
import { Permission } from 'src/app/core/resources/permission';
import { CompanyService } from 'src/app/core/services/company.service';
import { UploadDownloadMapService } from './uploadDownloadMap.service';
import { Router } from '@angular/router';
import { InsuranceInformation } from 'src/app/core/interfaces/insuranceInformation';
import { CostCenter } from 'src/app/core/interfaces/costCenter';
import { GeoValidationService } from 'src/app/core/services/geo-validation.service';
import { forkJoin, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, take } from 'rxjs/operators';
import { InsurancePolicyService, PolicyOwnerType, ResolvedPolicy } from 'src/app/core/services/insurance-policy.service';
import { Companies } from 'src/app/core/resources/companies';
import { buildMapInfoWindow } from "src/app/core/resources/map-info-window";
declare var google: any;

@Component({
  selector: 'app-upload-download-map-freight',
  templateUrl: './upload-download-map.component.html',
  styleUrls: ['./upload-download-map.component.scss'],
  providers: [Global]
})

export class UploadDownloadMapComponent implements OnInit, OnDestroy {

  permission = Permission;
  viewActive: string;
  showLocationsLoad = false;
  activeLocation: { typeLocation?, indexAddress?, indexDestination?} = {};
  panelOpenState = true;
  listCities: City[];
  cleanCity: boolean = false;
  @ViewChild(StandardMapComponent) standardMap: StandardMapComponent;
  @ViewChild(UploadLocationComponent) uploadLocationComponent: UploadLocationComponent;
  @ViewChild(DownloadLocationComponent) downloadLocationComponent: DownloadLocationComponent;
  @ViewChild(ThirdPartyConsignmentComponent) thirdPartyConsignmentComponent: ThirdPartyConsignmentComponent;
  cargoOwner: { documentType, documentNumber, branchOffice };
  numberDocumentSenderForm: string;
  locationSelected: { indexAddress, indexDestination };
  mapOptions: OptionsAutocomplete = {};
  listKeyMarkersOrigin: Array<string> = [];
  listKeyMarkersDestination: Array<string> = [];
  index: number;
  indexDestination: number;
  keyMarker: string = '';
  city: string = '';
  allowCreatingWithoutTruora: boolean = false;
  policy: InsuranceInformation;
  policyExpirated: boolean = false;
  policyOwnerType: PolicyOwnerType = null;
  policyTransportCompanyName: string = '';
  costCenterSetted: CostCenter;
  emptyCostCenter: CostCenter = {
    id: 0,
    code: '',
    name: '',
    active: false,
  }
  private citySub: Subscription = new Subscription();
  /**
   * Pipeline dedicado a la resolución de póliza. Vive fuera de `citySub`
   * a propósito: `resubscribeToCityChanges()` reemplaza `citySub` por
   * completo al refrescar el form, y si el pipeline de póliza estuviera
   * ahí adentro moriría silenciosamente en ese momento.
   */
  private policyRequest$ = new Subject<{ client: Company, transportCompanyId: string }>();
  private policySub: Subscription = new Subscription();
  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    public utils: Utils,
    private global: Global,
    private authService: AuthService,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinner: NgxSpinnerService,
    private cargoResources: CargoResources,
    private companyService: CompanyService,
    public uploadDownloadMapService: UploadDownloadMapService,
    private router: Router,
    private geoValidation: GeoValidationService,
    private insurancePolicyService: InsurancePolicyService,
    private snackBarService: SnackBarService,
    private originReteicaService: OriginReteicaService
  ) {
  }



  ngOnInit() {
    this.infoTruora();
    this.setCostCenter();
    if (history && history.state && history.state.type) this.setViewActive(history.state.type);
    else this.setViewActive('upload');
    this.subscribeToCityChanges();
    // El pipeline de policyRequest$ debe suscribirse antes de habilitar cualquier
    // emisor hacia el Subject (subscribeToTransportCompanyChanges): al ser un Subject
    // sin replay, una emisión que llegara antes de esta suscripción se perdería.
    this.policySub = this.policyRequest$.pipe(
      switchMap(request => this.insurancePolicyService.resolve(request.client, request.transportCompanyId).pipe(
        catchError(() => of({ policy: null, ownerType: null, transportCompany: null, expired: false } as ResolvedPolicy))
      ))
    ).subscribe(resolved => this.applyResolvedPolicy(resolved));
    this.subscribeToTransportCompanyChanges();
  }

  ngOnDestroy() {
    this.citySub.unsubscribe();
    this.policySub.unsubscribe();
  }

  private prevDestCodes: string[] = [];

  private subscribeToCityChanges(): void {
    this.citySub.add(
      this.manualCreationCargoService.formOrigin.valueChanges.pipe(
        map((v: any) => (v && v.municipalityCode) ? v.municipalityCode : ''),
        distinctUntilChanged()
      ).subscribe(code => {
        if (this.standardMap && this.viewActive === 'upload') {
          this.standardMap.removeMunicipalityPolygon('origin');
          if (code) this.loadAndShowPolygon(code, 'origin', '#2563eb');
        }
      })
    );
    this.citySub.add(
      this.manualCreationCargoService.formDestinations.valueChanges.pipe(
        map(dests => dests.map((d: any) => (d && d.municipalityCode) ? d.municipalityCode : '').filter((c: string) => !!c)),
        debounceTime(50)
      ).subscribe((codes: string[]) => {
        const prev = this.prevDestCodes;
        const removed = prev.filter(c => codes.indexOf(c) === -1);
        const added = codes.filter(c => prev.indexOf(c) === -1);
        this.prevDestCodes = codes.slice();
        if (!this.standardMap || this.viewActive !== 'destination') return;
        removed.forEach(code => this.standardMap.removeMunicipalityPolygon(`dest:${code}`));
        added.forEach(code => this.loadAndShowPolygon(code, `dest:${code}`, '#16a34a'));
      })
    );
  }

  /**
   * Recalcula la póliza cuando cambia la empresa de transporte. Si la
   * transportadora aplica la póliza del contratante el resultado es el mismo
   * y el cambio resulta transparente para el usuario.
   */
  private subscribeToTransportCompanyChanges(): void {
    const transportCompanyControl = this.manualCreationCargoService.cargoForm.get('transportCompany');
    if (!transportCompanyControl) return;
    this.citySub.add(
      transportCompanyControl.valueChanges.pipe(
        map((value: any) => (value && value.id) ? value.id : null),
        distinctUntilChanged()
      ).subscribe(transportCompanyId => {
        const owner = this.manualCreationCargoService.getOwnerSelected();
        if (owner) this.resolvePolicy(owner, transportCompanyId);
        this.syncWithTransportCompany(transportCompanyId);
      })
    );
  }

  /**
   * Re-subscribe a los valueChanges del cargoForm. Necesario porque
   * `manualCreationCargoService.refreshCargoForm()` reemplaza el FormGroup completo,
   * dejando las suscripciones previas apuntando a FormArrays huérfanos.
   */
  private resubscribeToCityChanges(): void {
    this.citySub.unsubscribe();
    this.citySub = new Subscription();
    // Sincronizar prevDestCodes con el estado actual del form para que el
    // próximo cambio detecte solo deltas (no todo el array como "nuevo").
    this.prevDestCodes = (this.manualCreationCargoService.formDestinations.value || [])
      .map((d: any) => d && d.municipalityCode ? d.municipalityCode : '')
      .filter((c: string) => !!c);
    this.subscribeToCityChanges();
    this.subscribeToTransportCompanyChanges();
  }

  /**
   * Renderiza en el mapa solo los polígonos relevantes a la vista actual.
   * - 'upload': borra polígonos de destinos y pinta el de origen.
   * - 'destination': borra polígono de origen y pinta los de todos los destinos.
   */
  private renderPolygonsForCurrentView(): void {
    if (!this.standardMap) return;
    this.standardMap.removeMunicipalityPolygon();
    if (this.viewActive === 'upload') {
      const code = this.manualCreationCargoService.formOrigin.get('municipalityCode').value;
      if (code) this.loadAndShowPolygon(code, 'origin', '#2563eb');
    } else if (this.viewActive === 'destination') {
      const codes: string[] = this.manualCreationCargoService.formDestinations.value
        .map((d: any) => d && d.municipalityCode ? d.municipalityCode : '')
        .filter((c: string) => !!c);
      if (!codes.length) return;
      const requests = codes.map((code, i) =>
        this.geoValidation.getMunicipalityPolygon(code).pipe(
          take(1),
          catchError(() => of(null)),
          map(poly => ({ code, poly, isLast: i === codes.length - 1 }))
        )
      );
      forkJoin(requests).subscribe(results => {
        results.forEach(({ code, poly, isLast }) => {
          if (poly && poly.geometry && this.standardMap) {
            this.standardMap.renderMunicipalityPolygon(poly.geometry, {
              key: `dest:${code}`,
              color: '#16a34a',
              fillOpacity: 0.1,
              fit: isLast
            });
          }
        });
      });
    }
  }

  public onMapReady(): void {
    this.renderPolygonsForCurrentView();
  }

  setCostCenter() {
    let isDefinedCostCenter = this.manualCreationCargoService && this.manualCreationCargoService.cargoForm && this.manualCreationCargoService.cargoForm.get('costCenter') && this.manualCreationCargoService.cargoForm.get('costCenter').value && this.manualCreationCargoService.cargoForm.get('costCenter').value.code;
    if (isDefinedCostCenter) this.costCenterSetted = this.manualCreationCargoService.cargoForm.get('costCenter').value;
    else this.costCenterSetted = this.emptyCostCenter;
  }

  private infoTruora() {
    const holderCompany = this.companyService.holderCompany;
    if (holderCompany && holderCompany.companyId)
      this.allowCreatingWithoutTruora = !!(holderCompany && holderCompany.allowCreatingWithoutTruora);
  }

  setViewActive(value: string) {
    this.viewActive = value;
  }

  onSelectOwner(event) {
    if (event && 'companyId' in event) {
      if (event && this.manualCreationCargoService && this.manualCreationCargoService.getOwnerSelected() && event.companyId !== this.manualCreationCargoService.getOwnerSelected().companyId) this.refreshCompaniesList(null);
      this.manualCreationCargoService.setOwnerSelected(event);
      this.manualCreationCargoService.setRequiresPreBill(event);
      this.manualCreationCargoService.setExpirationBillDays(event);
      this.setDefaultTransportCompany(event);
      this.setInfoPolicy(event);
    }
    if (event && event.options && event.options.clearListener) {
      this.mapOptionsConfig({
        clickMap: false,
        onlyListener: false,
        removeClickMapListener: true
      })
    } else {
      this.mapOptionsConfig({
        clickMap: true,
        onlyListener: true
      })
    }
    if (!(event as Company).branchOffices) {
      this.manualCreationCargoService.setBranchOfficeSelected(null);
      this.manualCreationCargoService.setSubBranchOfficeSelected(null);
    }
    if (event && event.data && (event.data.focusInput || event.data.refreshMarkers)) {
      this.activeLocation.typeLocation = 'cargoOwner';
      if (event.data.refreshMarkers) {
        this.standardMap.setCenterMap(event.data.location && event.data.location.lat ? event.data.location.lat : null, event.data.location && event.data.location.lng ? event.data.location.lng : null, 16)
        this.saveAddressSelected(event.data);
      }
    } else {
      this.activeLocation.typeLocation = null;
    }
  }

  /**
   * Los servicios adicionales y la reteica del origen dependen de la empresa de
   * transporte. Al cambiarla se quitan los servicios adicionales ya agregados y
   * se recalcula la reteica de la ciudad de origen (sin obligar a elegirla otra
   * vez); si la nueva empresa no tiene reteica para esa ciudad se limpia, igual
   * que al elegir una ciudad sin reteica.
   */
  private async syncWithTransportCompany(transportCompanyId: string): Promise<void> {
    const cargoForm = this.manualCreationCargoService.getCargoForm();
    const additionalCosts = cargoForm && cargoForm.get('additionalCosts');
    if (additionalCosts && additionalCosts.value && additionalCosts.value.length) {
      cargoForm.setControl('additionalCosts', new FormArray([]));
      this.snackBarService.openSnackBar(ServiceMessages.TRANSPORT_COMPANY_CHANGED_ADDITIONAL_COSTS_CLEARED, undefined, 'alert');
    }
    const origin = this.manualCreationCargoService.formOrigin;
    const municipalityCode = origin && origin.get('municipalityCode').value;
    if (!municipalityCode || origin.get('isInternational').value) return;
    const reteica = await this.originReteicaService.resolve(municipalityCode, transportCompanyId);
    // Cambió de nuevo mientras se consultaba: manda la consulta de la empresa vigente.
    if (transportCompanyId !== this.manualCreationCargoService.selectedTransportCompanyId) return;
    // Si la ciudad no aparece para la nueva empresa (o la consulta falla) se trata como
    // sin reteica: no se puede conservar la de la empresa anterior.
    if (reteica > 0) {
      origin.get('reteica').setValue(reteica);
    } else {
      origin.get('municipalityCode').setValue('');
      origin.get('reteica').setValue(0);
      this.snackBarService.openSnackBar(ServiceMessages.ORIGIN_CITY_WITHOUT_RETEICA_FOR_TRANSPORT_COMPANY, undefined, 'alert');
    }
  }

  private setDefaultTransportCompany(company: Company): void {
    const transportCompanyControl = this.manualCreationCargoService.cargoForm.get('transportCompany');
    if (transportCompanyControl)
      transportCompanyControl.setValue(company && company.transportCompany ? company.transportCompany : null);
  }

  setInfoPolicy(company: Company) {
    const transportCompanyControl = this.manualCreationCargoService.cargoForm.get('transportCompany');
    const transportCompanyValue = transportCompanyControl ? transportCompanyControl.value : null;
    const transportCompanyId = transportCompanyValue && transportCompanyValue.id ? transportCompanyValue.id : null;
    this.resolvePolicy(company, transportCompanyId);
  }

  private resolvePolicy(company: Company, transportCompanyId: string) {
    this.policyRequest$.next({ client: company, transportCompanyId: transportCompanyId });
  }

  private applyResolvedPolicy(resolved: ResolvedPolicy) {
    this.policy = resolved.policy;
    this.policyExpirated = resolved.expired;
    this.policyOwnerType = resolved.ownerType;
    this.policyTransportCompanyName = resolved.transportCompany && resolved.transportCompany.name
      ? resolved.transportCompany.name
      : '';
    this.uploadDownloadMapService.setPolicy(resolved.policy);
  }

  public onSelectBranch($event: BranchOffice): void {
    this.manualCreationCargoService.setBranchOfficeSelected($event);
    this.manualCreationCargoService.setSubBranchOfficeSelected(null);
  }

  public onSelectSubBranch($event: BranchOffice): void {
    this.manualCreationCargoService.setSubBranchOfficeSelected($event);
  }

  set addressOriginMapSelected($event: any) {
    if (this.manualCreationCargoService.getCargoForm().get('ministry').value && !this.manualCreationCargoService.formOrigin.get('isInternational').value) {
      if (this.uploadLocationComponent && this.uploadLocationComponent.thirdPartyConsignmentList) {
        const thirdPartyConsignmentArray = (this.uploadLocationComponent.thirdPartyConsignmentList as QueryList<ThirdPartyConsignmentComponent>).toArray();
        if (thirdPartyConsignmentArray && thirdPartyConsignmentArray[this.locationSelected.indexAddress]) {
          thirdPartyConsignmentArray[this.locationSelected.indexAddress].addressSelected = { address: $event.address, location: $event.location };
        }
      }
    } else {
      this.manualCreationCargoService.getFormOriginAddress(this.locationSelected.indexAddress).patchValue({
        address: $event.address,
        location: $event.location
      });
    }
  }

  public get ownerSelected(): Company {
    return this.manualCreationCargoService.getOwnerSelected();
  }

  public get branchOfficeSelected(): BranchOffice {
    return this.manualCreationCargoService.getBranchOfficeSelected();
  }

  set addressDestinationMapSelected($event: any) {
    if (this.downloadLocationComponent && this.downloadLocationComponent.thirdPartyConsignmentList) {
      const index = (this.downloadLocationComponent.thirdPartyConsignmentList as QueryList<ThirdPartyConsignmentComponent>).toArray()
        .findIndex((a) => {
          return a.options.index === this.locationSelected.indexAddress &&
            a.options.indexDestination === this.locationSelected.indexDestination;
        });
      if (this.manualCreationCargoService.getCargoForm().get('ministry').value &&
        !this.manualCreationCargoService.getFormDestination(this.locationSelected.indexDestination).get('isInternational').value) {
        if (index > -1) {
          const thirdPartyConsignmentArray = (this.downloadLocationComponent.thirdPartyConsignmentList as QueryList<ThirdPartyConsignmentComponent>).toArray();
          if (thirdPartyConsignmentArray && thirdPartyConsignmentArray[index]) {
            thirdPartyConsignmentArray[index].addressSelected = { address: $event.address, location: $event.location };
          }
        }
      } else {
        this.manualCreationCargoService.getFormDestinationAddresses(this.locationSelected.indexDestination)
          .at(this.locationSelected.indexAddress).patchValue(
            $event
          );
      }
    } else {
      this.manualCreationCargoService.getFormDestinationAddresses(this.locationSelected.indexDestination)
        .at(this.locationSelected.indexAddress).patchValue(
          $event
        );
    }
  }

  onLoadMap($event) {
    if (this.activeLocation && this.activeLocation.typeLocation) this.transformCoordinatesToAddress($event.latLng.lat(), $event.latLng.lng());
    this.mapOptionsConfig({
      removeClickMapListener: true,
      clickMap: false
    })
  }

  transformCoordinatesToAddress(lat: number, lng: number) {
    let geocoderService = new google.maps.Geocoder;
    let latlng = { lat: lat, lng: lng };
    this.spinner.show();
    geocoderService.geocode({ 'location': latlng }, (results, status) => {
      if (results.length) {
        this.spinner.hide();
        const data = this.setAddressDataToSave(results[0].formatted_address, lat, lng, this.activeLocation ? this.activeLocation.typeLocation : null, this.activeLocation ? this.activeLocation.indexAddress : null, this.activeLocation ? this.activeLocation.indexDestination : null)
        if (this.activeLocation.typeLocation !== 'cargoOwner') {
          let isOrigin = !(!!this.activeLocation.indexDestination || this.activeLocation.indexDestination === 0);
          this.standardMap.createInfoWindow(this.keyMarker, this.createContentInfoWindow(isOrigin, results[0].formatted_address, this.activeLocation ? Number(this.activeLocation.indexAddress) : null, this.city, this.city, this.activeLocation ? Number(this.activeLocation.indexDestination) : null), this.standardMap.markers[this.keyMarker])
        }
        this.saveAddressSelected(data);
      } else {
        this.spinner.hide();
      }
    });
  }

  addressRemovedOrigin(index: number) {
    if (index && this.standardMap) {
      var originAddresses = [];
      this.manualCreationCargoService.formOriginAddresses.controls.forEach((address, index) => {
        if (address && address.get('location') && address.get('location.lat') && address.get('location.lat').value && address.get('location.lng') && address.get('location.lng').value) {
          let originName = this.manualCreationCargoService.getFormOrigin().controls.name.value;
          originAddresses.push({
            index,
            addressName: address.get('address').value,
            originName: originName,
            key: `indexAddress:${index}`,
            lat: address.get('location.lat').value,
            lng: address.get('location.lng').value,
          })
        }
      })
      this.listKeyMarkersOrigin = this.utils.clone(this.standardMap.listMarkersKey);
      this.mapOptionsConfig({
        removeClickMapListener: true,
        clickMap: false
      })
      if (this.listKeyMarkersOrigin && this.listKeyMarkersOrigin.length) {
        this.listKeyMarkersOrigin.forEach(key => {
          if (!key.includes(`indexDestination`)) this.standardMap.removeMarker(key);
        })
        this.listKeyMarkersOrigin = [];
      }
      if (originAddresses && originAddresses.length) {
        originAddresses.forEach(address => {
          if (address && address.key && address.lat && address.lng) this.standardMap.createMarker(address.key, address.lat, address.lng, this.createContentInfoWindow(true, address.addressName, address.index, address.originName), address.index === 0 ? this.global.pathMarkerOrigin : this.global.pathLocationPin, address.index ? (address.index + 1).toString() : null)
        })
      }
    }
  }

  removeAllMarkersOrigin(remove: boolean) {
    if (remove && this.standardMap) {
      this.listKeyMarkersOrigin = this.utils.clone(this.standardMap.listMarkersKey);
      this.mapOptionsConfig({
        removeClickMapListener: true,
        clickMap: false
      })
      if (this.listKeyMarkersOrigin && this.listKeyMarkersOrigin.length) {
        this.listKeyMarkersOrigin.forEach(key => {
          if (!key.includes(`indexDestination`)) this.standardMap.removeMarker(key);
        })
        this.listKeyMarkersOrigin = [];
      }
    }
  }

  removeOneMarkerOneDestination(indexes) {
    if (indexes && (indexes.index || indexes.index === 0) && (indexes.indexDestination || indexes.indexDestination === 0) && this.standardMap) {
      var destinationAddresses = [];
      this.manualCreationCargoService.formDestinations.controls.forEach((destination, indexDestination) => {
        if (destination && destination.get('addresses') && destination.get('addresses').value && destination.get('addresses').value.length && indexes.indexDestination === indexDestination) {
          destination.get('addresses').value.forEach((address, index) => {
            if (address && address.location && address.location.lat && address.location.lng) {
              destinationAddresses.push({
                index,
                indexDestination,
                destination: destination.get('name').value,
                addressName: address.address,
                key: `indexAddress:${index}&indexDestination:${indexDestination}`,
                lat: address.location.lat,
                lng: address.location.lng,
              })
            }
          });
        }
      })
      this.listKeyMarkersDestination = this.utils.clone(this.standardMap.listMarkersKey);
      this.mapOptionsConfig({
        removeClickMapListener: true,
        clickMap: false
      })
      if (this.listKeyMarkersDestination && this.listKeyMarkersDestination.length) {
        this.listKeyMarkersDestination.forEach(key => {
          if (key.includes(`indexDestination:${indexes.indexDestination}`)) this.standardMap.removeMarker(key);
        })
        this.listKeyMarkersDestination = [];
      }
      if (destinationAddresses && destinationAddresses.length) {
        destinationAddresses.forEach(address => {
          if (address && address.key && address.lat && address.lng) this.standardMap.createMarker(address.key, address.lat, address.lng, this.createContentInfoWindow(false, address.addressName, address.index, null, address.destination, address.indexDestination), address.index === 0 ? this.global.pathMarkerOrigin : this.global.pathLocationPin, address.index ? (address.index + 1).toString() : null)
        })
      }

    }
  }

  removeAllMarkersOneDestination(indexDestination: number) {
    if (indexDestination || indexDestination === 0) {
      this.listKeyMarkersDestination = this.utils.clone(this.standardMap.listMarkersKey);
      this.mapOptionsConfig({
        removeClickMapListener: true,
        clickMap: false
      })
      if (this.listKeyMarkersDestination && this.listKeyMarkersDestination.length) {
        this.listKeyMarkersDestination.forEach(key => {
          if (key.includes(`indexDestination:${indexDestination}`)) this.standardMap.removeMarker(key);
        })
        this.listKeyMarkersDestination = [];
      }
    }
  }
  removeAllMarkersAllDestinations(remove: boolean) {
    if (remove && this.standardMap) {
      this.listKeyMarkersDestination = this.utils.clone(this.standardMap.listMarkersKey);
      this.mapOptionsConfig({
        removeClickMapListener: true,
        clickMap: false
      })
      if (this.listKeyMarkersDestination && this.listKeyMarkersDestination.length) {
        this.listKeyMarkersDestination.forEach(key => {
          if (key.includes('indexDestination:')) this.standardMap.removeMarker(key);
        })
        this.listKeyMarkersDestination = [];
      }
    }
  }

  private createContentInfoWindow(isOrigin: boolean, address: string, index: number, origin?: string, destination?: string, indexDestination?: number) {
    return buildMapInfoWindow({
      icon: 'fas fa-map-marker-alt',
      title: address ? address : 'Dirección sin definir',
      subtitle: isOrigin
        ? `Origen · dirección ${index + 1}`
        : `Destino ${indexDestination + 1} · dirección ${index + 1}`,
      rows: [
        { label: isOrigin ? 'Ciudad origen' : 'Ciudad destino', value: isOrigin ? origin : destination }
      ]
    });
  }

  receiveFromChildren($event: any) {
    this.city = $event && $event.options && $event.options.city && $event.options.city.name ? $event.options.city.name : '';
    this.index = $event && $event.options && ($event.options.index || $event.options.index === 0) ? $event.options.index : null;
    this.indexDestination = $event && $event.options && ($event.options.indexDestination || $event.options.indexDestination === 0) ? $event.options.indexDestination : null;
    this.activeLocation.indexAddress = this.index;
    this.activeLocation.indexDestination = this.indexDestination;
    let isOrigin = !(!!this.indexDestination || this.indexDestination === 0);
    this.keyMarker = this.index || this.index === 0 ? `indexAddress:${this.index}` : '';
    this.keyMarker += this.indexDestination || this.indexDestination === 0 ? `&indexDestination:${this.indexDestination}` : '';
    let labelIcon = this.index ? (this.index + 1).toString() : null;
    this.locationSelected = {
      indexAddress: this.index || this.index === 0 ? this.index : null,
      indexDestination: this.indexDestination || this.indexDestination === 0 ? this.indexDestination : null
    };
    if ($event && $event.data && $event.data.viewActive) {
      this.viewActive = $event.data.viewActive;
      this.renderPolygonsForCurrentView();
    }
    if ($event && $event.data && $event.data.refreshForm) {
      const cloneValue = this.utils.clone(this.manualCreationCargoService.cargoForm.value);
      this.manualCreationCargoService.refreshCargoForm(cloneValue);
      this.resubscribeToCityChanges();
      this.renderPolygonsForCurrentView();
    }
    //Actualizar o crear marker desde el autocomplete
    if ($event && $event.data && $event.data.refreshMarkers && $event.data.location && $event.data.location.lat && $event.data.location.lng) {
      this.activeLocation.typeLocation = 'address';
      this.standardMap.removeMapListener();
      this.standardMap.removeMarker(this.keyMarker);
      this.standardMap.createMarker(this.keyMarker, $event.data.location.lat, $event.data.location.lng, this.createContentInfoWindow(isOrigin, $event.data.address, this.index, $event.options.city.name, $event.options.city.name, !isOrigin ? this.indexDestination : null), this.index === 0 ? this.global.pathMarkerOrigin : this.global.pathLocationPin, this.index ? labelIcon : null);
      this.standardMap.setCenterMap($event.data.location.lat, $event.data.location.lng, 16);
      const data = this.setAddressDataToSave($event.data.address, $event.data.location.lat, $event.data.location.lng, this.activeLocation ? this.activeLocation.typeLocation : null, $event.options.index, $event && $event.options && $event.options.indexDestination ? $event.options.indexDestination : null);
      this.saveAddressSelected(data);
    }
    //Actualizar o crear marker desde el click del mapa
    if ($event && $event.data && $event.data.focusInput) {
      if ($event.options && $event.options.clearListener) {
        this.mapOptionsConfig({
          removeClickMapListener: true,
          removeMarker: true,
          clickMap: false,
          onlyListener: false
        });
      } else {
        this.mapOptionsConfig({
          keyMarkerListener: this.keyMarker ? this.keyMarker : null,
          removeClickMapListener: false,
          removeMarker: false,
          clickMapIcon: $event && $event.options && this.index === 0 ? this.global.pathMarkerOrigin : this.global.pathLocationPin,
          clickMap: true,
          labelIcon: labelIcon,
          onlyListener: false
        });
        const municipalityCode = $event && $event.options && $event.options.city && $event.options.city.municipalityCode;
        if (municipalityCode) {
          const isOriginFocus = !(this.indexDestination || this.indexDestination === 0);
          const key = isOriginFocus ? 'origin' : `dest:${municipalityCode}`;
          const color = isOriginFocus ? '#2563eb' : '#16a34a';
          this.loadAndShowPolygon(municipalityCode, key, color, false);
        }
      }
      this.activeLocation.typeLocation = 'address';
    }

    //Actualizar o crear marker si es un remitente o destinatario
    if ($event && $event.data && $event.data.thirdPartyConsignment && $event.data.thirdPartyConsignment.documentNumber && $event.data.location.lat && $event.data.location.lng) {
      this.standardMap.removeMapListener();
      this.standardMap.removeMarker(this.keyMarker);
      this.standardMap.createMarker(this.keyMarker, $event.data.location.lat, $event.data.location.lng, this.createContentInfoWindow(isOrigin, $event.data.address, this.index, $event.options.city.name, $event.options.city.name, !isOrigin ? this.indexDestination : null), this.index === 0 ? this.global.pathMarkerOrigin : this.global.pathLocationPin, this.index ? labelIcon : null);
      this.standardMap.setCenterMap($event.data.location.lat, $event.data.location.lng, 16);
      const data = this.setAddressDataToSave($event.data.address, $event.data.location.lat, $event.data.location.lng, this.activeLocation ? this.activeLocation.typeLocation : null, $event.options.index, $event && $event.options && ($event.options.indexDestination || $event.options.indexDestination === 0) ? $event.options.indexDestination : null);
      this.activeLocation.typeLocation = 'address';
      this.saveAddressSelected(data);
    }
  }

  private loadAndShowPolygon(cityId: string, key: string = 'default', color: string = '#2563eb', fit: boolean = true): void {
    this.geoValidation.getMunicipalityPolygon(cityId).pipe(
      take(1),
      catchError(() => of(null))
    ).subscribe(poly => {
      if (poly && poly.geometry && this.standardMap) {
        this.standardMap.renderMunicipalityPolygon(poly.geometry, { key, color, fillOpacity: 0.1, fit });
      }
    });
  }

  mapOptionsConfig(options: OptionsAutocomplete) {
    this.mapOptions = { ...this.mapOptions, ...options };
  }

  setAddressDataToSave(address: string, lat: number, lng: number, typeLocation: string, indexAddress: number, indexDestination?: number) {
    const data = {
      address: address,
      location: {
        lat,
        lng
      },
      typeLocation: typeLocation,
      indexAddress: indexAddress,
      indexDestination: indexDestination
    };
    return data;
  }

  saveAddressSelected(data) {
    if (this.activeLocation.typeLocation === 'cargoOwner') {
      this.thirdPartyConsignmentComponent.addressSelected = { address: data.address, location: data.location };
      this.activeLocation.typeLocation = null;
    } else if (this.activeLocation.typeLocation === 'address') {
      if (
        this.utils.isDefined(this.locationSelected) &&
        this.utils.isDefined(this.locationSelected.indexAddress) &&
        !this.utils.isDefined(this.locationSelected.indexDestination)
      ) {
        this.addressOriginMapSelected = data;
        this.activeLocation.typeLocation = null;
      } else if (
        this.utils.isDefined(this.locationSelected) &&
        this.utils.isDefined(this.locationSelected.indexAddress) &&
        this.utils.isDefined(this.locationSelected.indexDestination)
      ) {
        this.addressDestinationMapSelected = data;
        this.activeLocation.typeLocation = null;
      }
    }
  }


  onChangeManifestOption() {
    this.manualCreationCargoService.formOrigin.get('name').setValue('');
    let initialValue = this.utils.clone(this.cargoResources.cargoMock.cargoFeature.uploadDownload.origin);
    let initialValueDestination = this.utils.clone(this.cargoResources.cargoMock.cargoFeature.uploadDownload.destination);

    const basicAddress = this.utils.clone(this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.origin.addresses[0]);
    const basicAddressDestination = this.utils.clone(this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.destination[0].addresses[0]);
    this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.origin.addresses = [];
    this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.destination.forEach(destination => {
      destination.addresses = []
    });


    this.manualCreationCargoService.formOrigin.patchValue(initialValue);
    this.manualCreationCargoService.formDestinations.patchValue(initialValueDestination);

    let cloneValue = this.utils.clone(this.manualCreationCargoService.cargoForm.value);
    this.manualCreationCargoService.refreshCargoForm(cloneValue);
    this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.origin.addresses = [basicAddress];
    this.manualCreationCargoService.cargoMock.cargoFeature.uploadDownload.destination.forEach(destination => {
      destination.addresses = [basicAddressDestination]
    });
    this.manualCreationCargoService.formDestinations.patchValue(initialValueDestination);
    this.manualCreationCargoService.formOrigin.patchValue(initialValue);
    cloneValue = this.utils.clone(this.manualCreationCargoService.cargoForm.value);
    this.manualCreationCargoService.refreshCargoForm(cloneValue);
    this.resubscribeToCityChanges();
    // Limpia el texto visible de los autocompletes de ciudad (origen y destinos):
    // resetear sus inputFormControl hace que app-autocomplete-city sincronice su display.
    if (this.uploadLocationComponent) { this.uploadLocationComponent.cityControl.setValue(''); }
    this.manualCreationCargoService.cityDownloadControls.controls.forEach(control => control.setValue(''));
    this.removeAllMarkersOrigin(true);
    this.removeAllMarkersAllDestinations(true);
    this.renderPolygonsForCurrentView();
  }

  /** Describe de quién es la póliza vigente según el régimen que aplique. */
  get policyOwnerDescription(): string {
    if (this.policyOwnerType === 'client') { return 'Esta póliza es la del contratante'; }
    if (this.policyOwnerType === 'saasCompany') { return 'Esta póliza es la póliza única (para todos los clientes)'; }
    return `Esta póliza es la de la empresa de transporte ${this.policyTransportCompanyName}`;
  }

  redirectToCompany() {
    if (this.policyOwnerType === 'transportCompany') {
      this.router.navigate(['/administration/companies/config'], {
        queryParams: { tab: 'transport-companies' }
      });
      return;
    }
    // En el régimen sin transportadoras la póliza única vive en la empresa
    // SaaS, y se administra desde su propio detalle.
    const target = this.policyOwnerType === 'saasCompany'
      ? this.authService && this.authService.getCompanySaaS()
      : this.manualCreationCargoService.getOwnerSelected();
    if (!target || !target.companyId) return;
    this.router.navigate(['/administration/companies/detail', target.companyId], {
      state: { redirection: true }
    });
  }

  /**
   * El tab "Empresas de transporte" solo se renderiza para usuarios de una
   * empresa SaaS (company-config.component.ts, isPrincipalCompany). Sin este
   * guard, un usuario con permiso de póliza llegaría a /config y caería en un
   * tab sin relación con lo que venía a corregir.
   */
  get canEditPolicyDestination(): boolean {
    if (this.policyOwnerType !== 'transportCompany') return true;
    const saasCompany = this.authService && this.authService.getCompanySaaS();
    const userSession = this.authService && this.authService.getUserSession();
    return !!(
      saasCompany && saasCompany.companyId &&
      userSession && userSession.clientCompanyId &&
      this.authService.userIsFromRootNit() &&
      Companies.companiesAccess('/administration/companies/config', userSession.clientCompanyId, saasCompany.companyId)
    );
  }

  refreshCompaniesList(costCenterResponse: { costCenter: CostCenter, created: boolean } | null) {
    let costCenterSelected = costCenterResponse && costCenterResponse.costCenter && costCenterResponse.costCenter.code ? costCenterResponse.costCenter : null;
    if (costCenterResponse && costCenterResponse.created) this.thirdPartyConsignmentComponent.getCompanies(true);
    if (this.utils.isDefined(costCenterSelected) && this.utils.isDefined(costCenterSelected.code)) {
      this.manualCreationCargoService.cargoForm.get('costCenter').setValue(costCenterSelected);
      this.costCenterSetted = costCenterSelected;
    }
    else {
      this.costCenterSetted = this.emptyCostCenter
      this.manualCreationCargoService.cargoForm.get('costCenter').setValue(this.emptyCostCenter);
    }
  }

}
